module.exports = __webpack_public_path__ + "assets/img/kbldam.5fb3c924.png";